import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Circular from '../Circular/Circular';
import PropTypes from 'prop-types';
import Button from "components/CustomButtons/Button.js";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import MaskedInput from 'react-text-mask';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import { deleteLocker, syncLocker } from '../../services/lockers/lockers';
import { sendRabbitCommand, createRabbitPayload } from '../../services/actions/actions';


import CustomInputMask from "components/CustomInput/CustomInputMask.js"
import CustomInputMaskCpf from "components/CustomInput/CustomInputMaskCpf.js"

const useStyles = theme => ({
    iconView: {
        color: "gray !important"
    },
    root: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1),
            width: 200
        }
    },
    dialog: {
        '& .MuiPaper-root': {
            margin: theme.spacing(1),
            width: 250,
            height: 200
        }
    },
    green: {
        '& label.Mui-focused': {
            color: 'green'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        }
    },
    red: {
        '& label.Mui-focused': {
            color: 'red'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'red',
        }
    }
});

class Confirm extends Component {
    constructor(props) {
        super(props);
        this.deleteLocker = this.deleteLocker.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.updateOrder = this.updateOrder.bind(this);
        this.collectOrder = this.collectOrder.bind(this);
        this.handleCollect = this.handleCollect.bind(this);
        /*this.TextMaskCustom = this.TextMaskCustom.bind(this);
        this.TextMaskCustom.propTypes = {
            inputRef: PropTypes.func.isRequired,
        };*/

        this.state = {
            order: {},
            sizes: [
                {
                    value: 'small',
                    label: 'Small',
                },
                {
                    value: 'medium',
                    label: 'Medium',
                },
                {
                    value: 'large',
                    label: 'Large',
                },
                {
                    value: 'extra-large',
                    label: 'Extra-Large',
                }
            ],
            size: 'small',
            mobile_phone: '',
            name: null,
            cpf: null,
            email: null,
            numero_pedido: null,
            waiting: false,
            error: false
        }
    }

    deleteLocker = (lockerId, lockerName) => {
        deleteLocker(lockerId, (code) => {
            this.setState({ order: {}, waiting: false });
            this.props.onChange(false);
            console.log('code', code);
            (code === 200) ? this.props.setNotification(`Locker ${lockerName} deletado com sucesso!`, "success", 'confirm') : this.props.setNotification("Falha ao deletar locker!", "danger", 'confirm');
        });

    }

    syncLocker = (lockerId, lockerName) => {
        syncLocker(lockerId, (code) => {
            this.setState({ order: {}, waiting: false });
            this.props.onChange(false);
            console.log('code', code);
            (code === 200) ? this.props.setNotification(`Comando enviado com sucesso!`, "success", 'confirm') : this.props.setNotification("Falha ao enviar comando!", "danger", 'confirm');
        });

    }

    collectOrder = (lockerId, order) => {

        // console.log(JSON.stringify(order))

        const model = {
            orderId: order.id,
            status: order.status,
            size: order.size,
            // confirmState: order. ,
            //userId: order. ,
            externalOrderId: order.externalOrderId,
            allocationType: order.allocation_method,
            lockerId: order.lockerId,
            createdAt: order.createdAt,
            allocatedAt: order.allocatedAt,
            collectedAt: order.collectedAt,
            updatedAt: order.updatedAt,
            expiredAt: order.expiredAt,
            // senderType: order. ,
            senderId: order.senderId,

            // receiverUUId: order. ,
            // collectedBy: order. ,
            canceledAt: order.canceledAt,
            deliveryType: order.deliveryType,

            receiverId: order.receiverId,
            receiverPhone: order.receiverPhone,
            receiverEmail: order.receiverEmail,
            receiverCpf: order.receiverCpf,
            receiverName: order.receiverName,

            slotStatus: order.slot.status,
            slotLabel: order.slot.label,


            // bloco: order. ,
            // ap: order. ,
            // ala: order. ,

            collectToken: order.collectToken,
            deliveryToken: order.deliveryToken,
        }

        const payload = createRabbitPayload(lockerId, "COLLECT_ORDER_SLOT", model)
        console.log('Payload: ', JSON.stringify(payload));

        sendRabbitCommand(payload, (resp) => {

            this.setState({ order: {}, waiting: false });
            this.props.onChange(false);
            console.log('code', resp);
            (resp) ? this.props.setNotification(`Comando enviado com sucesso!`, "success", 'confirm') : this.props.setNotification("Falha ao enviar comando!", "danger", 'confirm');

        });
    }

    updateOrder = (lockerId, order) => {

        // console.log(JSON.stringify(order))

        const model = {
            orderId: order.id,
            status: order.status,
            size: order.size,
            // confirmState: order. ,
            //userId: order. ,
            externalOrderId: order.externalOrderId,
            allocationType: order.allocation_method,
            lockerId: order.lockerId,
            createdAt: order.createdAt,
            allocatedAt: order.allocatedAt,
            collectedAt: order.collectedAt,
            updatedAt: order.updatedAt,
            expiredAt: order.expiredAt,
            // senderType: order. ,
            senderId: order.senderId,

            // receiverUUId: order. ,
            // collectedBy: order. ,
            canceledAt: order.canceledAt,
            deliveryType: order.deliveryType,

            receiverId: order.receiverId,
            receiverPhone: order.receiverPhone,
            receiverEmail: order.receiverEmail,
            receiverCpf: order.receiverCpf,
            receiverName: order.receiverName,

            slotStatus: order.slot.status,
            slotLabel: order.slot.label,


            // bloco: order. ,
            // ap: order. ,
            // ala: order. ,

            collectToken: order.collectToken,
            deliveryToken: order.deliveryToken,
        }

        const payload = createRabbitPayload(lockerId, "UPDATE_ORDER", model)
        console.log('Payload: ', JSON.stringify(payload));

        sendRabbitCommand(payload, (resp) => {

            this.setState({ order: {}, waiting: false });
            this.props.onChange(false);
            console.log('code', resp);
            (resp) ? this.props.setNotification(`Comando enviado com sucesso!`, "success", 'confirm') : this.props.setNotification("Falha ao enviar comando!", "danger", 'confirm');

        });
    }

    handleChange = (event) => {
        console.log(event.target.id)
        switch (event.target.id) {
            case 'numero_pedido':
                this.setState({ numero_pedido: event.target.value })
                break;
            case 'email':
                this.setState({ email: event.target.value })
                break;
            case 'mobile_phone':
                this.setState({ mobile_phone: event.target.value })
                break;
            case 'cpf':
                this.setState({ cpf: event.target.value })
                break;
            case 'clientName':
                this.setState({ clientName: event.target.value })
                break;
            default:
                this.setState({ size: event.target.value })
                break;
        }
    }

    handleClickOpen = () => {
        this.props.onChange(true);
    };

    handleDelete = () => {
        let { lockerId, lockerName } = this.props
        this.deleteLocker(lockerId, lockerName)
    };

    handleSync = () => {
        let { lockerId, lockerName } = this.props
        this.syncLocker(lockerId, lockerName)
    };

    handleUpdate = () => {
        let { lockerId, order } = this.props
        this.updateOrder(lockerId, order)
    };

    handleCollect = () => {
        let { lockerId, order } = this.props
        this.collectOrder(lockerId, order)
    };

    handleClose = () => {
        this.props.onChange(false);
    };

    render() {
        const { classes, lockerName, lockerId, message, type, order } = this.props;
        console.log(message)
        return (
            <div>
                <Dialog className={(this.state.waiting) ? classes.dialog : null}
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{message}</DialogTitle>

                    <DialogActions>
                        {(type == 'sync') ?
                            <div>
                                <Button onClick={this.handleSync} color="success">
                                    Sim
                                </Button>
                                <Button onClick={this.handleClose} color="danger" autoFocus>
                                    Não
                                </Button>
                            </div>
                            : (type == 'delete') ?
                                <div>
                                    <Button onClick={this.handleDelete} color="success">
                                        Sim
                                    </Button>
                                    <Button onClick={this.handleClose} color="danger" autoFocus>
                                        Não
                                    </Button>
                                </div> : (type == 'update') ?
                                    <div>
                                        <Button onClick={this.handleUpdate} color="success">
                                            Sim
                                        </Button>
                                        <Button onClick={this.handleClose} color="danger" autoFocus>
                                            Não
                                        </Button>
                                    </div> :
                                        (type == 'collect') ?
                                        <div>
                                            <Button onClick={this.handleCollect} color="success">
                                                Sim
                                            </Button>
                                            <Button onClick={this.handleClose} color="danger" autoFocus>
                                                Não
                                            </Button>
                                        </div> :
                                        <div>
                                            <Button onClick={this.handleClose} color="primary">
                                                OK
                                            </Button>
                                        </div>
                        }
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
export default withStyles(useStyles)(Confirm);